import { CustomModal } from "components";
import { FilterableTable } from "components/FilterableTable";
import { Button } from "reactstrap";
import useModalReducer from "hooks/useModal";
import React, { useCallback } from "react";
import apiService from "services/api";
import { useMutation } from "react-query";
import ApproveAttendanceModal from "./ApproveAttendanceModal";
import { attendanceApplicationColumns } from "./constants";

const ViewAttendanceApplicationPage = () => {
	const [refetchCheck, setRefetchCheck] = React.useState(false);
	const { state, dispatch, actions } = useModalReducer();
	const viewAttendanceApplication = useCallback((row) => dispatch({ type: actions.OPEN, payload: row }), []);
	const hideAttendanceApplication = useCallback((row) => dispatch({ type: actions.CLOSE, payload: row }), []);

	return (
		<div className="content">
			<ApproveAttendanceModal
				show={state?.open}
				data={state.data}
				hideModal={hideAttendanceApplication}
				refetch={() => setRefetchCheck((prev) => !prev)}
			/>
			<FilterableTable
				query={(filters) => () => apiService.attendance.application.get(undefined, {}, filters)}
				title="Pending Attendance Applications"
				actionPrepend
				queryKey={["attendanceApplications", "pending"]}
				columns={attendanceApplicationColumns(viewAttendanceApplication)}
				refetchCheck={refetchCheck}
				filters={[
					{
						filterName: "date_from",
						operator: "contains",
						placeholder: "Date",
						type: "date",
						label: "Date From",
					},
					{
						filterName: "date_to",
						operator: "contains",
						placeholder: "Date",
						type: "date",
						label: "Date To",
					},
					{ filterName: "centre", operator: "contains", placeholder: "Centre" },
					{ filterName: "teacher_name", operator: "contains", placeholder: "Teacher Name" },
				]}
			/>
		</div>
	);
};

export default ViewAttendanceApplicationPage;
